<template>
  <el-breadcrumb class="breadcrumb" separator-class="el-icon-arrow-right">
    <slot></slot>
  </el-breadcrumb>
</template>
<script>
export default {
  name: 'Breadcrumb',
};
</script>
<style lang="scss" scoped>
.breadcrumb {
  padding: 30px 0;
  ::v-deep {
    .el-breadcrumb__inner {
      i {
        margin-right: 4px;
      }
    }
  }
}
</style>
